<template>
    <b-modal
        id="create-lp-deadline-series-modal"
        ref="create-lp-deadline-series-modal"
        size="md"
        :title="$t('learning_path.add_class')"
        modal-class="apprentice-default-modal create-deadline-series"
        :ok-title="$t('common.add')"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        @show="load()"
        @ok="onOk">
        <div class="lp-deadline-series-add">
            <div
                class="errors"
                v-if="errorsFound">
                <b-alert
                    v-for="(error, index) in errors"
                    v-if="error.error"
                    show
                    variant="danger"
                    :key="`error-${index}`"
                    >{{ error.message }}
                </b-alert>
            </div>
            <b-form-group
                class="deadline-series-name"
                label-for="deadline-series-name-input"
                :label="$t('common.name')">
                <template v-slot:label> {{ $t('common.name') }} <span class="required">*</span> </template>
                <b-form-input
                    id="lp-deadline-series-name-input"
                    v-model="name"
                    :placeholder="$t('common.name')">
                </b-form-input>
            </b-form-group>
            <b-form-group
                class="lp-deadline-menu-lasGroup(s)"
                label-for="lp-deadline-menu-lasGroup-input"
                label="Lesgroep(en)">
                <design-2021-apprentice-multiselect-component
                    v-model="lasGroups"
                    label="name"
                    :allow-empty="true"
                    :options="lasGroupsIn"
                    track-by="id">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>
            <b-form-group
                class="lp-deadline-menu-lasMainGroup(s)"
                label-for="lp-deadline-menu-lasMainGroup-input"
                label="Stamgroep(en)">
                <design-2021-apprentice-multiselect-component
                    v-model="lasMainGroups"
                    label="name"
                    :options="lasMainGroupsIn"
                    :allow-empty="true"
                    track-by="id">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>
            <div
                class="loading"
                v-show="loading">
                <i class="fas fa-spinner fa-spin"></i>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-create-learning-path-deadline-series-modal',
    props: ['lasGroupsIn', 'lasMainGroupsIn'],
    data() {
        return {
            lasGroups: [],
            lasMainGroups: [],
            name: '',
            loading: false,
            errorsFound: false,
            errors: {
                name: {
                    error: false,
                    message: this.$t('learning_path.name_cannot_be_empty'),
                },
            },
        };
    },
    methods: {
        onOk(bvModalEvent) {
            if (this.hasErrors()) {
                bvModalEvent.preventDefault();
                return;
            }
            let data = {
                name: this.name,
                lasGroups: this.lasGroups.map((lastGroup) => lastGroup.id),
                lasMainGroups: this.lasMainGroups.map((lastMainGroup) => lastMainGroup.id),
            };
            this.alert.saving();
            this.axios.post(this.routes.createDeadlineSeries(), data).then(
                (response) => {
                    this.$emit('createDeadlineSeries', response.data);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        load() {
            this.errorsFound = false;
            this.errors.name.error = false;
            this.lasGroups = [];
            this.lasMainGroups = [];
            this.name = '';
        },
        hasErrors() {
            this.errorsFound = false;
            this.errors.name.error = false;

            if (this.name === null || this.name === '') {
                this.errorsFound = true;
                this.errors.name.error = true;
                return true;
            }

            return false;
        },
    },
};
</script>
<style scoped></style>
